import React, { useRef, useEffect, useState } from "react";
import "./addInvestment.scss";
import { toast } from "react-toastify";
import Sidebar from "../../Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";

const Font = Quill.import("formats/font");
Font.whitelist = [
  "Montserrat",
  "Rollgates",
  "RollgatesItalic",
  "RollgatesBold",
];
Quill.register(Font, true);

const toolbarOptions = [
  [{ font: ["Montserrat", "Rollgates", "RollgatesItalic", "RollgatesBold"] }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: "1" }, { header: "2" }, { header: [3, 4, 5, 6] }],
  ["bold", "italic", "underline", "strike"],
  [{ color: [] }, { background: [] }],
  [{ script: "sub" }, { script: "super" }],
  ["blockquote", "code-block"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ align: [] }],
  ["link"],
  ["clean"],
];

const CustomDropdown = ({ options, selectedValues, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelect = (value) => {
    const newSelectedValues = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];
    onChange(newSelectedValues);
    setIsOpen(false); // Close dropdown after selection
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="custom-dropdown-faAdd" ref={dropdownRef}>
      <div className="dropdown-header-faAdd" onClick={handleToggle}>
        {selectedValues.length > 0
          ? selectedValues.join(", ")
          : "Select Available Sports"}
      </div>
      {isOpen && (
        <div className="dropdown-options-faAdd">
          {options.map((option) => (
            <div
              key={option}
              className={`option-faAdd ${
                selectedValues.includes(option) ? "selected" : ""
              }`}
              onClick={() => handleSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

function AddInvestment() {
  const navigate = useNavigate();
  const [facilityDetails, setFacilityDetails] = useState({
    facility_name: "",
    locality: "",
    city: "",
    country: "",
    direction_link: "",
    available_sports: [],
    sport_info: {
      football: {
        "5a_side": { max_players: 0, min_players: 0, num_of_courts: 0 },
        "7a_side": { max_players: 0, min_players: 0, num_of_courts: 0 },
      },
      cricket: {
        "5a_side": { max_players: 0, min_players: 0, num_of_courts: 0 },
        "7a_side": { max_players: 0, min_players: 0, num_of_courts: 0 },
      },
      paddle: { max_players: 0, min_players: 0, num_of_courts: 0 },
      pickleball: { max_players: 0, min_players: 0, num_of_courts: 0 },
      tennis: { max_players: 0, min_players: 0, num_of_courts: 0 },
      badminton: { max_players: 0, min_players: 0, num_of_courts: 0 },
      tabletennis: { max_players: 0, min_players: 0, num_of_courts: 0 },
    },
    club_timings: {
      "Mon-Fri": { start_time: "", close_time: "" },
      "Sat-Sun": { start_time: "", close_time: "" },
    },
    facility_contact: "",
    facility_type: "",
  });
  const [hideFormatBox, setHideFormatBox] = useState(false);

  const handleGoBack = () => {
    navigate("/admin/facility");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const baseUrl =
      "https://ballersapi.ballerslife.co/api/v1/admin/membership/sports_facility/add_a_facility";
    const accessToken = window.localStorage.getItem("access_token");

    const requestData = {
      facility_name: facilityDetails.facility_name,
      locality: facilityDetails.locality,
      city: facilityDetails.city,
      country: facilityDetails.country,
      direction_link: facilityDetails.direction_link,
      available_sports: facilityDetails.available_sports,
      sport_info: facilityDetails.sport_info,
      club_timings: facilityDetails.club_timings,
      facility_contact: facilityDetails.facility_contact,
      facility_type: facilityDetails.facility_type,
    };
    console.log(requestData, "requestData");
    try {
      const response = await fetch(baseUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      if (response.status === 200) {
        toast.success(data.message);
        navigate("/admin/investments");
      } else if (response.status === 422) {
        toast.error(data.detail[0].msg);
      } else {
        toast.error(data.detail);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  useEffect(() => {
    document.title = `Add Details | Ballers`;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const Added = () => {
    try {
      // Extract text content from Quill HTML
      const textContent = new DOMParser()
        .parseFromString(quilData, "text/html")
        .body.textContent.trim();

      let updatedValue;
      if (newName === "sport_info") {
        updatedValue = JSON.parse(textContent);
        // Validate sport_info structure
        const isValidStructure = Object.keys(updatedValue).every(
          (sport) =>
            facilityDetails.available_sports.includes(sport) &&
            (sport === "football" || sport === "cricket"
              ? Object.keys(updatedValue[sport]).every(
                  (side) =>
                    ["5a_side", "7a_side"].includes(side) &&
                    Object.keys(updatedValue[sport][side]).every((key) =>
                      ["max_players", "min_players", "num_of_courts"].includes(
                        key
                      )
                    )
                )
              : Object.keys(updatedValue[sport]).every((key) =>
                  ["max_players", "min_players", "num_of_courts"].includes(key)
                ))
        );
        if (!isValidStructure) {
          throw new Error("Invalid sport info structure");
        }
      } else if (newName === "club_timings") {
        updatedValue = JSON.parse(textContent);
        const isValidStructure = Object.keys(updatedValue).every(
          (day) =>
            ["Mon-Fri", "Sat-Sun"].includes(day) &&
            Object.keys(updatedValue[day]).every((key) =>
              ["start_time", "close_time"].includes(key)
            )
        );
        if (!isValidStructure) {
          throw new Error("Invalid club timings structure");
        }
      } else {
        updatedValue = textContent; // For simple string fields
      }

      setFacilityDetails((prevState) => ({
        ...prevState,
        [newName]: updatedValue,
      }));
      setHideFormatBox(false);
    } catch (e) {
      console.error("Invalid input format:", e);
      toast.error(
        `Please enter valid ${
          newName === "sport_info"
            ? "JSON matching the sport info structure"
            : newName === "club_timings"
            ? "JSON matching the club timings structure"
            : "text"
        }`
      );
    }
  };

  const [newName, setNewName] = useState("");
  const [spanData, setSpanData] = useState("");
  const [placeholder, setPlaceholder] = useState("");
  const [quilData, setQuilData] = useState("");

  const addData = (eventName, event) => {
    setPlaceholder(event.target.textContent || event.target.value);
    if (
      typeof facilityDetails[eventName] === "string" &&
      facilityDetails[eventName].length === 0
    ) {
      setSpanData(event.target.textContent || event.target.value);
      setQuilData("");
    } else if (
      event.target.innerText?.length === 1 ||
      event.target.value?.length === 1
    ) {
      setSpanData(event.target.textContent || event.target.value);
      setQuilData("");
    } else {
      // Predefine content based on the field
      if (
        eventName === "sport_info" &&
        facilityDetails.available_sports.length > 0
      ) {
        const predefinedSportInfo = Object.fromEntries(
          facilityDetails.available_sports.map((sport) => [
            sport,
            facilityDetails.sport_info[sport] || {
              ...(sport === "football" || sport === "cricket"
                ? {
                    "5a_side": {
                      max_players: 0,
                      min_players: 0,
                      num_of_courts: 0,
                    },
                    "7a_side": {
                      max_players: 0,
                      min_players: 0,
                      num_of_courts: 0,
                    },
                  }
                : { max_players: 0, min_players: 0, num_of_courts: 0 }),
            },
          ])
        );
        setQuilData(JSON.stringify(predefinedSportInfo, null, 2));
      } else if (eventName === "club_timings") {
        const predefinedClubTimings = {
          "Mon-Fri": { start_time: "", close_time: "" },
          "Sat-Sun": { start_time: "", close_time: "" },
        };
        setQuilData(JSON.stringify(predefinedClubTimings, null, 2));
      } else {
        setQuilData(facilityDetails[eventName] || "");
      }
      setSpanData("");
    }
    setNewName(eventName);
    setHideFormatBox(true);
  };

  const handleQuilInput = (html) => {
    if (html === "<p><br></p>") {
      setSpanData(placeholder);
      setQuilData("");
      return;
    } else {
      setQuilData(html);
    }
  };

  const formatBox = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (formatBox.current && !formatBox.current.contains(event.target)) {
        setHideFormatBox(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sportsOptions = [
    "football",
    "cricket",
    "paddle",
    "pickleball",
    "tennis",
    "tabletennis",
    "badminton",
  ];
  const handleAvailableSportsChange = (newSelectedValues) => {
    setFacilityDetails((prevState) => ({
      ...prevState,
      available_sports: newSelectedValues,
    }));
  };

  // Filter sport_info to show only selected sports for display
  const filteredSportInfo = Object.fromEntries(
    Object.entries(facilityDetails.sport_info).filter(([sport]) =>
      facilityDetails.available_sports.includes(sport)
    )
  );

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content" style={{ position: "relative" }}>
        <div className="goBackSvg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#FFBF00"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="lucide lucide-chevron-left"
            onClick={handleGoBack}
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="invMainForm">
            <div className="inpInfoMain">
              <p>Facility Name :</p>
              <span
                contentEditable="false"
                autoComplete="off"
                name="facility_name"
                placeholder="Please provide Facility Name"
                dangerouslySetInnerHTML={{
                  __html:
                    facilityDetails.facility_name ||
                    "Please provide Facility Name",
                }}
                required
                onClick={(e) => addData("facility_name", e)}
                className="custom-span"
              />
            </div>
            <div className="inpInfoMain">
              <p>Locality :</p>
              <span
                contentEditable="false"
                autoComplete="off"
                name="locality"
                placeholder="Please provide Locality"
                dangerouslySetInnerHTML={{
                  __html: facilityDetails.locality || "Please provide Locality",
                }}
                required
                onClick={(e) => addData("locality", e)}
                className="custom-span"
              />
            </div>
            <div className="inpInfoMain">
              <p>City :</p>
              <span
                contentEditable="false"
                autoComplete="off"
                name="city"
                placeholder="Please provide City"
                dangerouslySetInnerHTML={{
                  __html: facilityDetails.city || "Please provide City",
                }}
                required
                onClick={(e) => addData("city", e)}
                className="custom-span"
              />
            </div>
            <div className="inpInfoMain">
              <p>Country :</p>
              <span
                contentEditable="false"
                autoComplete="off"
                name="country"
                placeholder="Please provide Country"
                dangerouslySetInnerHTML={{
                  __html: facilityDetails.country || "Please provide Country",
                }}
                required
                onClick={(e) => addData("country", e)}
                className="custom-span"
              />
            </div>
            <div className="inpInfoMain">
              <p>Direction Link :</p>
              <span
                contentEditable="false"
                autoComplete="off"
                name="direction_link"
                placeholder="Please provide Direction Link"
                dangerouslySetInnerHTML={{
                  __html:
                    facilityDetails.direction_link ||
                    "Please provide Direction Link",
                }}
                required
                onClick={(e) => addData("direction_link", e)}
                className="custom-span"
              />
            </div>
            <div className="inpInfoMain">
              <p>Available Sports :</p>
              <CustomDropdown
                options={sportsOptions}
                selectedValues={facilityDetails.available_sports}
                onChange={handleAvailableSportsChange}
              />
            </div>
            <div className="inpInfoMain">
              <p>Sport Info :</p>
              <span
                contentEditable="false"
                autoComplete="off"
                name="sport_info"
                placeholder="Please provide Sport Info (e.g., max/min players, courts)"
                dangerouslySetInnerHTML={{
                  __html:
                    Object.keys(filteredSportInfo).length > 0
                      ? JSON.stringify(filteredSportInfo, null, 2)
                      : "Please provide Sport Info",
                }}
                required
                onClick={(e) => addData("sport_info", e)}
                className="custom-span"
              />
            </div>
            <div className="inpInfoMain">
              <p>Club Timings :</p>
              <span
                contentEditable="false"
                autoComplete="off"
                name="club_timings"
                placeholder="Please provide Club Timings (e.g., Mon-Fri 07:00-22:00)"
                dangerouslySetInnerHTML={{
                  __html:
                    Object.entries(facilityDetails.club_timings)
                      .map(
                        ([days, { start_time, close_time }]) =>
                          `${days}: ${start_time} - ${close_time}`
                      )
                      .join("<br />") || "Please provide Club Timings",
                }}
                required
                onClick={(e) => addData("club_timings", e)}
                className="custom-span"
              />
            </div>
            <div className="inpInfoMain">
              <p>Facility Contact :</p>
              <span
                contentEditable="false"
                autoComplete="off"
                name="facility_contact"
                placeholder="Please provide Facility Contact"
                dangerouslySetInnerHTML={{
                  __html:
                    facilityDetails.facility_contact ||
                    "Please provide Facility Contact",
                }}
                required
                onClick={(e) => addData("facility_contact", e)}
                className="custom-span"
              />
            </div>
            <div className="inpInfoMain">
              <p>Facility Type :</p>
              <span
                contentEditable="false"
                autoComplete="off"
                name="facility_type"
                placeholder="Please provide Facility Type"
                dangerouslySetInnerHTML={{
                  __html:
                    facilityDetails.facility_type ||
                    "Please provide Facility Type",
                }}
                required
                onClick={(e) => addData("facility_type", e)}
                className="custom-span"
              />
            </div>
          </div>
          <div className="btnMainSec">
            <button className="updateBtn" type="submit">
              <p>Add Details</p>
            </button>
          </div>
        </form>
        {hideFormatBox ? (
          <div className="formatText" ref={formatBox}>
            <ReactQuill
              theme="snow"
              modules={{ toolbar: toolbarOptions }}
              placeholder={spanData}
              value={quilData}
              onChange={(e) => handleQuilInput(e)}
              className="formatTextContainer"
            />
            <div className="editedSubmit">
              <button onClick={Added}>Submit</button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default AddInvestment;
